import { render, staticRenderFns } from "./Formedit.vue?vue&type=template&id=23fe203c&scoped=true"
import script from "./Formedit.vue?vue&type=script&lang=js"
export * from "./Formedit.vue?vue&type=script&lang=js"
import style0 from "./Formedit.vue?vue&type=style&index=0&id=23fe203c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23fe203c",
  null
  
)

export default component.exports